module.exports = "<div class=show-history-dialog aria-label=showHistoryDialog ng-cloak> <md-toolbar class=md-primary> <div class=md-toolbar-tools> <span>Historikk</span> <span flex></span> <md-button class=\"md-icon-button white-hoverable-button\" ng-click=c.cancel()> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <div layout=column flex class=dialog-body> <rkc-table table-definition=c.tableDefinition table-content=c.forecastHistory></rkc-table> <div layout=row> <span flex></span> <md-button class=\"md-raised md-accent cancel-button\" ng-click=c.cancel()> Lukk </md-button> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/prognosis/showHistoryDialog/showHistoryDialog.html
 ** module id = 528
 ** module chunks = 0
 **/